export default __webpack_public_path__ + "static/media/spirit_visage.9aae5722.png";